import { InteractionManager, Platform } from 'react-native';

/**
 * After ASWebAuthenticationSession / SFSafariViewController returns, iOS may still be
 * tearing down the auth shell's modal. Presenting another RN Modal immediately causes:
 * "Attempt to present RCTFabricModalHostViewController ... which is already presenting ...".
 * Defer the callback until interactions settle plus a short platform-specific delay.
 */
export function schedulePresentAfterAuthSessionDismiss(onPresent: () => void): () => void {
  let cancelled = false;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  InteractionManager.runAfterInteractions(() => {
    if (cancelled) return;
    const ms =
      Platform.OS === 'ios' ? 650 : Platform.OS === 'android' ? 220 : 0;
    timeoutId = setTimeout(() => {
      timeoutId = null;
      if (!cancelled) onPresent();
    }, ms);
  });

  return () => {
    cancelled = true;
    if (timeoutId) clearTimeout(timeoutId);
  };
}
